import React, { useEffect, useState } from "react";
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Outlet, useLocation, useMatch } from "react-router-dom";

import ClubhouseSidebar from "./Sidebar";

import "../../../assets/css/majorybl/pages/clubhouse.scss";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { isXOrSmaller, scrollToTop } from "../../../lib/utils";

const ClubhouseLayout = (): React.JSX.Element => {
    const pathMatch = useMatch("/coachs-clubhouse");
    const [navBarCollapsed, setNavBarCollapsed] = useState(false);
    const location = useLocation();
    useEffect(() => {
        scrollToTop();
        setNavBarCollapsed(true);
    }, [location.pathname]);
    const breakpoint = useBreakpoint();

    const toggleNavbar = () => {
        isXOrSmaller("md", breakpoint) && setNavBarCollapsed(!navBarCollapsed);
    };

    return (
        <Container
            className="py-1 py-lg-5 clubhouse"
            data-testid="clubhouseContent"
        >
            <Row>
                {!pathMatch && (
                    <Col lg={3} xl={2}>
                        <Navbar expand="lg" expanded={!navBarCollapsed}>
                            <Navbar.Toggle
                                aria-controls="basic-navbar-nav"
                                onClick={toggleNavbar}
                            />
                            {isXOrSmaller("md", breakpoint) && (
                                <Navbar.Text>
                                    <h4>Menu</h4>
                                </Navbar.Text>
                            )}
                            <Navbar.Collapse>
                                <ClubhouseSidebar
                                    breakpoint={breakpoint}
                                    toggleNavbar={toggleNavbar}
                                />
                            </Navbar.Collapse>
                        </Navbar>
                    </Col>
                )}
                <Col>
                    <Outlet />
                </Col>
            </Row>
        </Container>
    );
};

export default ClubhouseLayout;
